import {LastCallError} from './LastCallError.js'

export class DealerNotFoundError extends LastCallError {
  constructor({errorType, detail}) {
    super({errorType, detail})
  }
}
